import React from 'react';
import { appUrl } from '../../../utils';
import './capital-flight-filters.css';
export const capitalFlightFilterAssets = { '--capital-air-slider-handle': `url("${appUrl('/Content/capital/assets/air-slider-handle.svg')}")` };
export function CapitalFlightFilterCheckBox({ label, checked, onChange }) {
    return React.createElement("label", { className: "capital-flight-filter-checkbox" },
        React.createElement("input", { type: "checkbox", checked: checked, onChange: event => onChange === null || onChange === void 0 ? void 0 : onChange(event.target.checked) }),
        React.createElement("span", { className: "capital-flight-filter-checkbox-icon", "aria-hidden": "true" },
            React.createElement("img", { src: appUrl('/Content/capital/assets/air-checkbox-checked.svg'), alt: "" })),
        React.createElement("span", null, label));
}
